<template>
  <div class="ad-container ">
    <div
      v-if="showLandscape() || landscapeRendered"
      v-show="showLandscape() && landscapeRendered"
      class="landscape landscape-container"
    >
      <div class="ad-container-right">
        <div class="ad-item">
          <AdsenseRect data-ad-slot="4847553020"></AdsenseRect>
        </div>
        <div class="ad-item">
          <AdsenseRect data-ad-slot="2088354280"></AdsenseRect>
        </div>
      </div>
      <div :class="adContainerBottomClass" class="ad-container-bottom">
        <div v-if="!isMobile" class="ad-item">
          <AdsenseHorizontal
            v-if="!isDPAD"
            data-ad-slot="3808630063"
          ></AdsenseHorizontal>
          <a v-if="isDPAD" :href="dpadLink"><img :src="dpadPC"/></a>
        </div>
        <div v-if="isMobile" class="ad-item">
          <AdsenseSp v-if="!isDPAD" data-ad-slot="1640905370"></AdsenseSp>
          <a v-if="isDPAD" :href="dpadLink"><img :src="dpadSP"/></a>
        </div>
      </div>
    </div>
    <div
      v-if="showPortrait() || portraitRendered"
      v-show="showPortrait() && portraitRendered"
      class="portrait portrait-container"
    >
      <div class="ad-container-item ad-container-p-top">
        <div class="ad-item">
          <AdsenseSp v-if="!isDPAD" data-ad-slot="2589889491"></AdsenseSp>
          <a v-if="isDPAD" :href="dpadLink"><img :src="dpadSP"/></a>
        </div>
      </div>
      <div
        :class="adContainerBottomClass"
        class="ad-container-item ad-container-p-bottom"
      >
        <div class="ad-item">
          <AdsenseSp v-if="!isDPAD" data-ad-slot="1276807828"></AdsenseSp>
          <a v-if="isDPAD" :href="dpadLink"><img :src="dpadSP"/></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import platform from 'platform'
import AdsenseRect from './AdsenseRect'
import AdsenseHorizontal from './AdsenseHorizontal'
import AdsenseSp from './AdsenseSp'

const isMobile = () => {
  return ['iOS', 'Android'].includes(platform.os.family)
}
const checkOri = () => {
  if (!screen.orientation) {
    return Math.abs(window.orientation) === 90 ? 'landscape' : 'portrait'
  }
  const { type } = screen.orientation

  return type.match(/^landscape/) ? 'landscape' : 'portrait'
}

const $ = window.$
const RESET_AD_INTERVAL = 90 * 1000

export default {
  components: {
    AdsenseRect,
    AdsenseHorizontal,
    AdsenseSp
  },
  data() {
    return {
      portrait: window.orientation === 0,
      $video: null,
      $rightCompanion: null,
      $bottomCompanion: null,
      $portrait: null,
      $landscaple: null,
      isMobile: isMobile(),
      portraitRendered: false,
      landscapeRendered: false,
      isDPAD: !!window.LVPS_DPAD_LINK,
      dpadLink: window.LVPS_DPAD_LINK,
      dpadPC: window.LVPS_DPAD_728,
      dpadSP: window.LVPS_DPAD_320
    }
  },
  computed: {
    adContainerBottomClass() {
      return {
        'dpad-link': this.isDPAD
      }
    }
  },
  mounted() {
    this.initializeData()
    this.initializeEvents()
  },
  methods: {
    initializeData() {
      this.$data.$video = $('#video')
      this.$data.$rightCompanion = $('.landscape .ad-container-right')
      this.$data.$bottomCompanion = $('.landscape .ad-container-bottom')
      this.$data.$portrait = $('.portrait-container')
      this.$data.$landscape = $('.landscape-container')
    },
    initializeEvents() {
      window.addEventListener('orientationchange', this.handleOrientationChange)
      this.handleOrientationChange()

      $(window)
        .resize(this.handleResize.bind(this))
        .resize()
      this.$data.$video.on('canplay', () => {
        setTimeout(this.handleResize.bind(this), 3000)
      })

      this.resetAd()

      if (this.isMobile) {
        setInterval(this.handleResize.bind(this), 3000)
      }
    },
    resetAd() {
      setInterval(() => {
        console.log('Reset ads.')
        $('.ad-item:visible > ins').each(function() {
          $(this).attr('data-adsbygoogle-status', '')
          window.adsbygoogle.push({})
        })
      }, RESET_AD_INTERVAL)
    },
    handleResize() {
      console.log('handle resize')
      this.$data.$rightCompanion = $('.landscape .ad-container-right')
      this.$data.$bottomCompanion = $('.landscape .ad-container-bottom')

      const windowH = window.innerHeight
      const videoH = this.$data.$video.height() + 90
      const videoW = this.$data.$video.width()
      const rightH = this.$data.$rightCompanion.height()
      const rightW = this.$data.$rightCompanion.width()
      const bottomW = this.$data.$bottomCompanion.width()
      const bottomH = this.$data.$bottomCompanion.height()
      const scaleR =
        windowH < 500 ? windowH / 500 : videoH > 500 ? 1 : videoH / rightH
      const scaleB = videoW > 728 ? 1 : videoW / bottomW
      const $playerContainer = $('.player-container')

      $playerContainer.css({
        paddingRight: `${rightW * scaleR}px`,
        paddingBottom: `${isMobile() ? bottomH : bottomH * scaleB}px`
      })

      if (
        isMobile() &&
        $playerContainer.hasClass('plyr--fullscreen-fallback') &&
        videoH > windowH - (window.LVPS_AD_ENABLED ? 90 : 0)
      ) {
        this.$data.$video.height(windowH - (window.LVPS_AD_ENABLED ? 90 : 0))
      }

      if (isMobile() && this.$data.portrait) {
        $playerContainer.css({
          paddingRight: 0,
          paddingBottom: 0
        })
      }

      this.$data.$rightCompanion.css({
        transform: `scale(${scaleR})`
      })
      if (isMobile()) {
        this.$data.$bottomCompanion.css({
          width: `${this.$data.$video.width()}px`
        })
      } else {
        this.$data.$bottomCompanion.css({
          transform: `scale(${scaleB})`
        })
      }
    },
    handleOrientationChange() {
      const container = document.getElementById('playerContainer')

      if (checkOri() === 'portrait') {
        container.classList.remove('landscape')
        container.classList.add('portrait')
        this.$data.portrait = true
        this.moveVideoToPortrait()
      } else {
        container.classList.remove('portrait')
        container.classList.add('landscape')
        this.$data.portrait = false
        this.moveVideoToLandscape()
      }
    },
    async moveVideoToPortrait() {
      await Vue.nextTick()
      const $to = $('.ad-container-p-top')
      const $target = $('#videoRoot')

      $target.insertAfter($to)
      this.$emit('domChanged')
    },
    async moveVideoToLandscape() {
      await Vue.nextTick()
      const $to = $('#playerContainer')
      const $target = $('#videoRoot')

      $target.prependTo($to)
      this.$emit('domChanged')
    },
    showLandscape() {
      const show = !isMobile() || !this.$data.portrait

      if (show) {
        this.$data.landscapeRendered = true
      }

      return show
    },
    showPortrait() {
      const show = isMobile() && this.$data.portrait

      if (show) {
        this.$data.portraitRendered = true
      }

      return show
    }
  }
}
</script>

<style lang="sass" scoped>
.mobile
  .landscape
    .ad-container-bottom
      .ad-item
        width: 320px
        height: 50px
.landscape
  .ad-container-right
    width: 300px
    position: absolute
    top: 0
    right: 0
    display: flex
    flex-direction: column
    justify-content: space-around
    transform-origin: right top
    .ad-item
      width: 300px
      height: 250px

  .ad-container-bottom
    height: 105px
    width: 728px
    box-sizing: border-box
    position: absolute
    bottom: 0
    left: 0
    text-align: center
    transform-origin: left bottom
    .ad-item
      height: 105px
      width: 728px
      margin: 0 auto

.portrait
  .ad-container-item
    width: 100%
    height: 50px
    text-align: center

  .ad-container-p-top
    .ad-item
      width: 320px
      height: 50px
      margin: 0 auto

  .ad-container-p-bottom
    .ad-item
      width: 320px
      height: 50px
      margin: 0 auto

.mobile
  .dpad-link
    height: 50px !important
    .ad-item
      height: 50px !important

.dpad-link
  height: 90px !important
  .ad-item
    height: 90px !important

  img
    width: 100%
</style>



// WEBPACK FOOTER //
// src/components/AdContainer.vue